<template>
    <b-card>
        <b-row>
            <b-col lg="12">
                <b-row class="justify-content-between">
                    <b-col sm="6" md="4" class="d-flex align-items-center justify-content-between my-1">
                        <date-picker
                            v-model="start_date"
                            placeholder="Start Date"
                            class="f-1">
                        </date-picker> &nbsp;to&nbsp;
                        <date-picker
                            v-model="end_date"
                            placeholder="End Date"
                            class="f-1">
                        </date-picker>
                    </b-col>

                    <b-col sm="6" md="4" class="my-1" v-if="!isCarrierManager">
                        <carrier-parents-dropdown v-model="parent_carrier" :role="role"></carrier-parents-dropdown>
                    </b-col>
                    <b-col sm="6" md="4" class="my-1">
                        <carrier-dropdown v-model="carrier" :role=" role "></carrier-dropdown>
                    </b-col>
                </b-row>

                <b-row class="my-2 justify-content-end">
                    <b-col sm="6" md="4" class="d-flex align-items-center justify-content-end">
                        <b-btn class="my-1 mr-1" variant="success"
                               :href="`/documents/reports/provider-feedback${this.appliedFilters}&export=1`"
                               :disabled="loading"><i class="fa fa-file-excel-o"></i> Export to Excel
                        </b-btn>

                        <b-button class="my-1" @click=" reload() " variant="info" :disabled=" loading ">Generate
                        </b-button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>

        <div class="table-responsive">
            <b-row class="my-4">
                <b-col lg="3">
                    <b>Total Falls:</b> {{ this.falls }}
                </b-col>
                <b-col lg="3">
                    <b>Total Hospitalizations:</b> {{ this.hospitalizations }}
                </b-col>
            </b-row>

            <loading-card v-if="loading"/>

            <b-table striped show-empty v-else @row-clicked="selectRow" :items="tableItems" :fields="fields">
                <template v-slot:cell(claimant_name)="row">
                    {{row.value}}
                </template>
                <template v-slot:row-details="row">
                    <table class="table">
                        <tbody>
                        <tr>
                            <th>Event type</th>
                            <th>Event Time</th>
                        </tr>
                        <tr v-for="claimant_event  in tableItems[row.index].events">
                            <td>{{claimant_event.event_type}}</td>
                            <td>{{claimant_event.event_date}}</td>
                        </tr>
                        </tbody>
                    </table>
                </template>
            </b-table>
        </div>
    </b-card>
</template>

<script>
import UsesRole from "../../../mixins/UsesRole";

export default {
    props: ['role'],
    mixins: [UsesRole],
    data() {
        return {
            loading: false,
            end_date: moment(new Date()).format('MM/DD/YYYY'),
            start_date: moment(new Date()).subtract(14, 'days').format('MM/DD/YYYY'),
            caregiver_id: '',
            items: [],
            falls: 0,
            hospitalizations: 0,
            parent_carrier: '',
            carrier: '',
            selected_row: null,
            fields: [
                {
                    key: "claimant_name",
                    label: "Claimant Name",
                    sortable: true,
                },
                {
                    key: "policy_number",
                    label: "Policy Number",
                    sortable: true,
                },
                {
                    key: "intake_id",
                    label: "Intake Id",
                    sortable: true
                },
                {
                    key: "carrier_block",
                    label: "Carrier Block",
                    sortable: true,
                },
                {
                    key: "falls",
                    label: "Falls(s)",
                    sortable: true,
                },
                {
                    key: "hospitalizations",
                    label: "Hospitalization(s)",
                    sortable: true,
                },
            ],
        }
    },

    computed: {
        appliedFilters() {
            return `?start_date=${this.start_date}&end_date=${this.end_date}&carrier=${this.carrier}&parent_carrier_id=${this.parent_carrier}`;
        },
        tableItems() {
            return this.items.map(item => ({ ...item, showDetails: false }))
        }
    },

    methods: {
        formatDate(date) {
            return moment.utc(date).local().format('L LT');
        },

        reload() {
            this.loading = true;
            axios.get(`/documents/reports/provider-feedback${this.appliedFilters}`)
                .then(({data}) => {
                    this.items = data && Array.isArray(data.items) ? data.items : [];
                    this.falls = 'falls' in data ? data.falls : 0;
                    this.hospitalizations = 'hospitalizations' in data ? data.hospitalizations : 0;
                    this.loading = false;
                });
        },

        selectRow(item, index) {
            const detailsRow = this.tableItems[index];
            this.$set(detailsRow, '_showDetails', !detailsRow._showDetails);
        }
    }
}
</script>